import React from 'react'
import styled from 'styled-components'

import { media } from 'styles/media'

import LogoAustralian from '../../../../components/icons/LogoAustralian'
import LogoBroadsheet from '../../../../components/icons/LogoBroadsheet'
import LogoFinancialReview from '../../../../components/icons/LogoFinancialReview'
import LogoPedestrian from '../../../../components/icons/LogoPedestrian'
import LogoTimeOut from '../../../../components/icons/LogoTimeOut'
import LogoUrbanList from '../../../../components/icons/LogoUrbanList'
import LogoMonsterChildren from '../../../../components/icons/LogoMonsterChildren'

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;

  color: ${({ theme }) => theme?.['-ds-neutral-600']?.value};

  ${media.md`
    flex-direction: row;
    flex-wrap: wrap;
    justify-content: center;
    max-width: 1000px;
    margin: 0 auto;
  `}
`

const LogoWrapper = styled.div`
  flex-grow: 0;
  flex-shrink: 0;
  margin-bottom: 16px;

  svg {
    opacity: 0.8;
    width: 304px;
    height: 64px;
  }
`

const Anchor = styled.a.attrs({
  target: '_blank',
  rel: 'noopener noreferrer',
})``

const PressLogos = () => {
  return (
    <Outer>
      <LogoWrapper>
        <Anchor href="https://www.broadsheet.com.au/melbourne/travel/article/looking-adventure-now-you-can-find-it">
          <LogoBroadsheet />
        </Anchor>
      </LogoWrapper>
      <LogoWrapper>
        <Anchor href="https://www.theurbanlist.com/a-list/riparide-travel-company">
          <LogoUrbanList />
        </Anchor>
      </LogoWrapper>
      <LogoWrapper>
        <Anchor href="https://www.afr.com/life-and-luxury/travel/the-escape-to-nature-portal-millennials-are-choosing-over-airbnb-stays-20210930-p58vyy">
          <LogoFinancialReview />
        </Anchor>
      </LogoWrapper>
      <LogoWrapper>
        <Anchor href="https://www.theaustralian.com.au/business/airbnb-rival-riparide-books-4m-as-covid-restrictions-ease/news-story/8b1181aac149afc6523364f87e0d5210">
          <LogoAustralian />
        </Anchor>
      </LogoWrapper>
      <LogoWrapper>
        <Anchor href="https://www.pedestrian.tv/travel/oz-travel-platform-riparide/">
          <LogoPedestrian />
        </Anchor>
      </LogoWrapper>
      <LogoWrapper>
        <Anchor href="https://www.timeout.com/melbourne/travel/victorian-stays-to-book-on-riparide">
          <LogoTimeOut />
        </Anchor>
      </LogoWrapper>
      <LogoWrapper>
        <Anchor href="https://www.monsterchildren.com/best-airbnb-alternatives-for-booking-your-next-trip/">
          <LogoMonsterChildren />
        </Anchor>
      </LogoWrapper>
    </Outer>
  )
}

export default PressLogos
